import { Map } from 'immutable'

import { isAuthorizedOrLoading } from '../selectors'

import { AuthorizationRecordMock } from './utils/records'

const initialState = Map({ authorization: new AuthorizationRecordMock() })

describe('Authorization service selectors', () => {
    describe('isAuthorizedOrLoading', () => {
        test('isLoading is true', () => {
            const state = initialState.setIn(['authorization', 'isLoading'], true)

            expect(isAuthorizedOrLoading(state)).toBe(true)
        })

        test('isAuthorization is true', () => {
            const state = initialState.setIn(['authorization', 'isAuthorized'], true)

            expect(isAuthorizedOrLoading(state)).toBe(true)
        })

        test('isLoading is false and isAuthorization is false', () => {
            const state = initialState

            expect(isAuthorizedOrLoading(state)).toBe(false)
        })
    })
})
